export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives4.259555f0.jpg";